import { FetchResult, gql } from 'apollo-boost';
import { MultiError } from '../../../types/multi-error';
import { graphqlClient } from '../../graphql-client';

const MUTATION = gql`
    mutation LearningChunkSetIndex($uid: String!, $index: Int!){
        learning_chunk_set_index (uid: $uid, index: $index) {
            success
        }
    }
`;

export async function learningChunkSetIndex(uid: string, index: number): Promise<{ success: boolean }> {
    const result: FetchResult<{ learning_chunk_set_index: { success: boolean }}> = await graphqlClient.mutate({
        mutation: MUTATION,
        variables: { uid, index },
        errorPolicy: 'all',
    });

    if(!result.data || result.errors && result.errors.length) {
        throw new MultiError(result.errors || ['Unknown error']);
    }

    return result.data.learning_chunk_set_index;
}
